<form [formGroup]="form">
  <div class="inputs">
    <label>Password </label>
    <div caInputContainer>
      <input
        caInput
        [type]="showPassword ? 'text' : 'password'"
        autocomplete="new-password"
        formControlName="newPassword"
        (blur)="onTouched()"
        (input)="onChange($event.target.value)"
      />
      <button
        class="show-password"
        mat-icon-button
        color="primary"
        aria-label="Show password"
        (click)="showPassword = !showPassword"
        type="button"
      >
        <mat-icon>{{
          showPassword ? "visibility" : "visibility_off"
        }}</mat-icon>
      </button>
    </div>
    <div
      [ngClass]="'strengthIndicator passwordStrength_' + (score$ | async)"
    ></div>
    <p class="strengthLabel">{{ score$ | async | passwordStrength }}</p>

    <label>Confirm password </label>
    <div caInputContainer>
      <input
        caInput
        [type]="showConfirmPassword ? 'text' : 'password'"
        autocomplete="new-password"
        formControlName="confirmPassword"
        (input)="onTouched()"
      />
      <button
        class="show-password"
        mat-icon-button
        color="primary"
        aria-label="Show password"
        (click)="showConfirmPassword = !showConfirmPassword"
        type="button"
      >
        <mat-icon>{{
          showConfirmPassword ? "visibility" : "visibility_off"
        }}</mat-icon>
      </button>
    </div>
  </div>
  <div class="errors" *ngIf="(errors$ | async)?.length > 0">
    Your password needs:
    <ul>
      <li *ngFor="let error of errors$ | async">{{ error }}</li>
    </ul>
  </div>
</form>
